import { render, staticRenderFns } from "./MyRank.vue?vue&type=template&id=52167e48&scoped=true&"
import script from "./MyRank.vue?vue&type=script&lang=js&"
export * from "./MyRank.vue?vue&type=script&lang=js&"
import style0 from "./MyRank.vue?vue&type=style&index=0&id=52167e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52167e48",
  null
  
)

export default component.exports